import { useMemo } from 'react'
import { type GroupedOptionsType } from 'react-select'
import { useFetchPartnersWithRetailersQuery } from 'domains/account-management/api'

export const useAccountManagementRetailers = (partnerIds: string[]) => {
  const { data, loading, error } = useFetchPartnersWithRetailersQuery({
    variables: { ids: partnerIds },
  })

  const partners = data?.partners

  type OptionType = {
    label: string
    value: string
  }

  const options: GroupedOptionsType<OptionType> = useMemo(() => {
    if (!partners) return []

    return partners.map(partner => ({
      label: partner.name,
      value: partner.id,
      options: partner.retailers?.map(retailer => ({
        label: retailer.name,
        value: retailer.id,
      })),
    }))
  }, [partners])

  return {
    options,
    loading,
    error,
  }
}
